<script setup lang="ts">
import { ENTERPRISES } from '~~/src/types/enterprise'

const emit = defineEmits<{
  (event: 'logo-click', e: MouseEvent): void
}>()

const dropdownRef = ref<HTMLDivElement>()
const [showDropdown, setShowDropdown] = useFloatingElement(dropdownRef, { enableMouseLeave: true })

const currentEnterprise = useEnterprise()

const handleEnterpriseSwap = (enterprise_id: number) => {
  setEnterprise(enterprise_id)
  setShowDropdown(false)
}
</script>

<template>
  <div>
    <div flex>
      <div>
        <NuxtLink to="/" hover="filter brightness-95" duration-125 aria-label="Snack Prompt" title="Go home" @click="(e) => emit('logo-click', e)">
          <IconLogo v-if="currentEnterprise === 1" />
          <img
            v-else
            :src="ENTERPRISES.filter(e => e.id === currentEnterprise)[0]?.avatar"
            w="36px"
            h="36px"
            rounded-full
          >
        </NuxtLink>
      </div>
    </div>
    <AppFloatingMenu v-if="showDropdown" ref="dropdownRef" absolute w-64>
      <div>
        <AppHeaderEnterpriseOption :enterprise="ENTERPRISES.filter(e => e.id === currentEnterprise)[0]" is-active />
        <AppHeaderEnterpriseOption
          v-for="enterprise in ENTERPRISES.filter(ent => ent.id !== currentEnterprise)"
          :key="enterprise.id"
          :enterprise="enterprise"
          @click="() => handleEnterpriseSwap(enterprise.id)"
        />
      </div>
    </AppFloatingMenu>
  </div>
</template>
